import { render, staticRenderFns } from "./DealerEdit.vue?vue&type=template&id=57f526c8&scoped=true"
import script from "./DealerEdit.vue?vue&type=script&lang=js"
export * from "./DealerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f526c8",
  null
  
)

export default component.exports